/* compare.js — spec-powered product comparison (the feature competitors lack).
 * Compare list in localStorage; modal builds a union-spec table from compare-row sections. */
(() => {
  'use strict';
  const KEY = 'st_compare', MAX = 4;
  const read = () => { try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch { return []; } };
  const write = (a) => { localStorage.setItem(KEY, JSON.stringify(a)); paint(); };
  const bar = document.getElementById('CompareBar');
  const modal = document.getElementById('CompareModal');
  const STAR = '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 2.6l2.9 5.9 6.5.95-4.7 4.58 1.11 6.47L12 17.45 6.19 20.5 7.3 14.03 2.6 9.45l6.5-.95z"/></svg>';
  const stars = (r) => r > 0 ? `<span class="rating__stars" style="--pct:${Math.round(r * 20)}%"><span class="rating__stars-row">${STAR.repeat(5)}</span><span class="rating__stars-fill" aria-hidden="true">${STAR.repeat(5)}</span></span>` : '';

  function paint() {
    const list = read();
    document.querySelectorAll('[data-compare]').forEach((b) => b.classList.toggle('is-active', list.some((x) => x.handle === b.dataset.handle)));
    if (!bar) return;
    bar.hidden = list.length === 0;
    bar.querySelector('[data-compare-count]').textContent = list.length;
    bar.querySelector('[data-compare-items]').innerHTML = list.map((x) =>
      `<span class="compare-chip">${x.title}<button data-compare data-handle="${x.handle}" data-title="${x.title}" aria-label="Remove">×</button></span>`).join('');
  }

  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-compare]');
    if (b) {
      e.preventDefault(); // compare buttons can sit inside the card anchor
      const list = read(), h = b.dataset.handle;
      if (list.some((x) => x.handle === h)) write(list.filter((x) => x.handle !== h));
      else if (list.length < MAX) write([...list, { handle: h, title: b.dataset.title }]);
      else { bar?.classList.add('shake'); setTimeout(() => bar?.classList.remove('shake'), 400); }
    }
    if (e.target.closest('[data-compare-clear]')) write([]);
    if (e.target.closest('[data-compare-close]')) { modal.setAttribute('aria-hidden', 'true'); document.body.classList.remove('drawer-open'); }
    if (e.target.closest('[data-compare-open]')) openModal();
  });

  async function openModal() {
    const list = read();
    if (!list.length || !modal) return;
    const body = modal.querySelector('[data-compare-body]');
    body.innerHTML = '<div class="qv-modal__loading">Loading…</div>';
    modal.setAttribute('aria-hidden', 'false'); document.body.classList.add('drawer-open');
    const data = await Promise.all(list.map(async (x) => {
      try { const r = await fetch(`/products/${x.handle}?section_id=compare-row`); const d = document.createElement('div'); d.innerHTML = await r.text(); return JSON.parse(d.querySelector('[data-compare-json]').textContent); } catch { return null; }
    }));
    const prods = data.filter(Boolean);
    const keys = []; prods.forEach((p) => Object.keys(p.specs || {}).forEach((k) => { if (!keys.includes(k)) keys.push(k); }));
    body.innerHTML = `<table class="compare-table"><thead><tr><th></th>${prods.map((p) => `
      <th><a href="${p.url}"><span class="media" style="aspect-ratio:1/1;display:block;border-radius:6px;overflow:hidden">${p.image ? `<img src="${p.image}" alt="" width="200" height="200" loading="lazy">` : ''}</span>
      <span class="compare-th__vendor">${p.vendor || ''}</span><span class="compare-th__title">${p.title}</span></a>
      <span class="compare-th__price">${p.price}</span> <span class="compare-th__stars">${stars(p.rating)}</span>
      <button class="btn btn--add" style="margin:.5rem 0" data-compare-add data-id="${p.variant_id}" ${p.available ? '' : 'disabled'}>${p.available ? 'Add' : 'Sold out'}</button>
      <button class="compare-th__remove" data-compare data-handle="${p.handle}" data-title="${p.title}">Remove</button></th>`).join('')}</tr></thead>
      <tbody>${keys.map((k) => `<tr><th>${k}</th>${prods.map((p) => `<td>${(p.specs && p.specs[k]) || '—'}</td>`).join('')}</tr>`).join('')}</tbody></table>`;
  }

  // add-to-cart from compare
  document.addEventListener('click', async (e) => {
    const a = e.target.closest('[data-compare-add]');
    if (!a) return;
    const api = window.SydneyTaps && window.SydneyTaps.cart;
    if (api) { // optimistic add + drawer via the cart island
      const row = a.closest('[data-compare-row], .compare__col, .compare__item');
      api.add([{ id: a.dataset.id, quantity: 1, hint: { product_title: a.dataset.title || (row && row.querySelector('.compare__title, h3, h4')?.textContent.trim()) || null } }]);
      document.dispatchEvent(new CustomEvent('cart:added'));
      return;
    }
    a.setAttribute('aria-busy', 'true');
    try { await fetch(window.routes.cart_add_url + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: a.dataset.id, quantity: 1 }) }); document.dispatchEvent(new CustomEvent('cart:added')); }
    finally { a.removeAttribute('aria-busy'); }
  });

  paint();
})();
